module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//house-store.png?v=f24ced2d";